var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9583 6.02205L12.4224 0.884302C12.153 0.33927 11.608 0 11.0001 0C10.3923 0 9.84646 0.33927 9.57709 0.884302L7.03021 6.03069L1.36 6.85452C0.757634 6.94169 0.266791 7.35557 0.0790929 7.93437C-0.109391 8.51239 0.0445376 9.13595 0.480406 9.56083L4.58778 13.574L3.61944 19.2214C3.51656 19.8206 3.75845 20.4159 4.25008 20.7732C4.52809 20.9751 4.85322 21.078 5.18071 21.078C5.43281 21.078 5.68648 21.0167 5.92051 20.8942L11.0072 18.2279L16.079 20.8942C16.6177 21.1769 17.2578 21.1314 17.7494 20.7732C18.241 20.4159 18.4837 19.8214 18.3808 19.2214L17.4164 13.5606L21.5199 9.56083C21.9557 9.13595 22.1089 8.51317 21.9212 7.93437C21.7335 7.35557 21.2426 6.94169 20.6403 6.85452L14.9701 6.03069L14.9583 6.02205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/a2.26f50446f82fcd84bed1d756e4c3c513.svg";
export { ForwardRef as ReactComponent };